import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type IconVariant =
  | "cardPrimary"
  | "cardSecondary"
  | "footerContact"
  | "footerSocial";

type AppIconsProp = {
  icon: IconDefinition;
  variant?: IconVariant;
  className?: string;
};

const variantClasses: Record<IconVariant, string> = {
  cardPrimary: "",
  cardSecondary: "",
  footerContact: "text-yellow w-4 h-4",
  footerSocial: "",
};

export const AppIcons = ({
  icon,
  variant = "cardPrimary",
  className,
}: AppIconsProp) => {
  return <FontAwesomeIcon icon={icon} 
  className={`${variantClasses[variant]} ${className}`} />;
};
